import { useMemo } from 'react'
import { useReactiveVar } from '@apollo/client'
import { balanceVar } from 'shared/store/balance-store'
import { activeBalanceClaimSwitchTypeVar } from '../store/switch-types'
import { ClaimBalanceSwitchTypes } from '../types'
import { getFormattedBalances } from '../utils/get-formatted-balances'

export const useApprovedBalanceField = () => {
  const activeType = useReactiveVar(activeBalanceClaimSwitchTypeVar)

  const onlyInteger = activeType === ClaimBalanceSwitchTypes.Claim

  const balance = useReactiveVar(balanceVar)

  const { formattedBalance, formattedTreasury } = getFormattedBalances(balance)

  const maxAmount = useMemo(() => {
    if (activeType === ClaimBalanceSwitchTypes.Deposit) {
      return formattedBalance
    }

    if (activeType === ClaimBalanceSwitchTypes.Claim) {
      return Math.floor(formattedTreasury)
    }

    return formattedBalance
  }, [activeType, formattedBalance, formattedTreasury])

  return { maxAmount, isApprove: false, onlyInteger }
}
